import { HttpInterceptorFn } from '@angular/common/http';
import { API_CONFIG } from '../config/api.config';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!API_CONFIG.baseUrl || req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }
  const apiReq = req.clone({ url: `${API_CONFIG.baseUrl}${req.url}` });
  return next(apiReq);
};
